import React, { useEffect, useState } from "react";
import { Button, Input, InputLabel, Slider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const InheritableDrivingSpeedSlider: React.FC<{
  value: number;
  onChange: (newValue: number) => void;
  label: string;
  subButton?: {
    label: string;
    startIcon?: React.ReactNode;
    onClick: () => void;
  };
  overrideText?: string;
}> = ({ value, label, onChange, subButton, overrideText }) => {
  const { t } = useTranslation();

  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const sliderChangeHandler = (event: Event, newValue: number | number[], _: number) => {
    setLocalValue(newValue as number);
  };

  const commitHandler = () => {
    onChange(localValue);
  };

  const inputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Math.max(Math.min(100, +event.target.value), 0));
  };

  return (
    <Stack>
      <InputLabel>{t(label)}</InputLabel>
      {overrideText != null ? (
        <Typography>{overrideText}</Typography>
      ) : (
        <Stack direction="row" spacing={2}>
          <Slider
            value={localValue}
            onChange={sliderChangeHandler}
            min={0}
            max={100}
            step={1}
            valueLabelDisplay="off"
            onChangeCommitted={commitHandler}
          />
          <Input
            inputProps={{
              step: 1,
              min: 0,
              max: 100,
              type: "number",
            }}
            value={localValue}
            onChange={inputChangeHandler}
            onBlur={commitHandler}
            sx={(theme) => ({ width: theme.spacing(6) })}
          />
        </Stack>
      )}
      {subButton != null && (
        <Button
          onClick={subButton.onClick}
          variant="text"
          size="small"
          startIcon={subButton.startIcon}
          sx={{ width: "max-content" }}
        >
          {subButton.label}
        </Button>
      )}
    </Stack>
  );
};

export default InheritableDrivingSpeedSlider;
